var React = require('react');

function SuccessIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-519 -2359)"},[React.createElement("g",{"transform":"translate(519 2359)","fill":"none","stroke":"#1a826a","strokeWidth":"1.5","key":0},[React.createElement("rect",{"width":"26","height":"26","rx":"13","stroke":"none","key":0}),React.createElement("rect",{"x":"0.75","y":"0.75","width":"24.5","height":"24.5","rx":"12.25","fill":"none","key":1})]),React.createElement("path",{"d":"M-3243.667,301.993l4.548,4.548,8.269-8.269","transform":"translate(3769.167 2069.228)","fill":"none","stroke":"#1a826a","strokeWidth":"1.5","key":1})]));
}

SuccessIcon.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = SuccessIcon;

SuccessIcon.default = SuccessIcon;
